module.exports = __webpack_public_path__ + "img/cloundcheckveinbg.6215f7e7.png";